module.exports = __webpack_public_path__ + "static/media/IMG_2414.6d0aaf5e.jpeg";